import React from 'react';

const Modal = ({ message }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-xl font-semibold text-center">{message}</h2>
        <div className="flex flex-col gap-2 justify-center mt-4">
        <div className='text-center '>You are being logged out...</div>
          <button className="bg-red-500 text-white p-2 rounded" onClick={() => window.location.reload()}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
